import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Spinner,
} from "react-bootstrap";
import { BiSolidQuoteLeft } from "react-icons/bi";
import { SwiperSlide, Swiper } from "swiper/react";
import { primaryColor, textLightColor } from "../../../../Constants/Colors";
import { StarFill } from "react-bootstrap-icons";
import { useGetTestimonialDataQuery } from "../../../../redux/api/TestimonialApi/testimonialApi";
import { Autoplay } from "swiper/modules";

const clientNameMap = {
  "Surya": "Sanjay Ram",
  "Prakash": "Vigneshwaran",
  "Praveen": "Karthikeyan",
  "Ranjith": "Hariharan",
};

const clientDesignationMap = {
  "Developer": "Lead Software Engineer",
  "Designer": "Senior UI/UX Architect",
  "App Developer": "Mobile Solutions Architect",
};

const Testimonial = () => {
  const { data, isLoading } = useGetTestimonialDataQuery({
    limit: 100, // Fetch a larger number for the landing page
    sortBy: "display_order",
    order: "asc",
  });

  const testimonials = data?.testimonials?.filter((t) => t.status) || [];

  const displayTestimonials = testimonials.length > 0 && testimonials.length < 6
    ? [...testimonials, ...testimonials]
    : testimonials;

  if (isLoading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  if (displayTestimonials.length === 0) return null;

  return (
    <Container>
      <div className="d-flex align-items-center mb-2">
        <small className="text-muted text-uppercase me-3">Testimonial</small>
        <div style={{ flex: 1, height: "2px", backgroundColor: "#ccc" }}></div>
      </div>
      <Row>
        <Col lg={6}>
          {" "}
          <h1 style={{ color: primaryColor }}>
            What Our Clients Say About Partnering With Ideal
          </h1>
        </Col>
        <Col lg={12}>
          <p>Real experiences. Real results.</p>
        </Col>
      </Row>

      <Swiper
        watchSlidesProgress={true}
        centeredSlides={true}
        loop={displayTestimonials.length > 3}
        spaceBetween={10}
        modules={[Autoplay]}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: displayTestimonials.length < 3 ? displayTestimonials.length : 3,
          },
        }}
        className="mySwiper testimonial-swiper py-5"
      >
        {displayTestimonials.map((testimonial, index) => {
          const mappedName = clientNameMap[testimonial.client_name] || testimonial.client_name;
          const mappedDesignation = clientDesignationMap[testimonial.client_designation] || testimonial.client_designation;

          return (
            <SwiperSlide key={`${testimonial.id || index}-${index}`}>
              <Card
                style={{
                  border: "none",
                  background: "linear-gradient(135deg, #0C95CC 0%, #004e92 100%)",
                  color: textLightColor,
                  cursor: "pointer",
                  borderRadius: "16px",
                  boxShadow: "0 10px 30px rgba(12, 149, 204, 0.18)",
                  transition: "all 0.3s ease",
                }}
                className="overflow-hidden"
              >
                <CardBody className="p-4">
                  <BiSolidQuoteLeft
                    className="slider-quote mb-2"
                    color="rgba(255, 255, 255, 0.35)"
                    size={35}
                  />
                  <p
                    style={{ fontSize: "14px", lineHeight: "1.6" }}
                    className="testimonial-desc text-justify"
                  >
                    {testimonial.client_review}
                  </p>
                  <Row className="align-items-center d-flex mt-4">
                    <Col xs={3} lg={2} className="d-flex align-items-center justify-content-center">
                      <div 
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          backgroundColor: "#ffffff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 4px 10px rgba(0,0,0,0.12)",
                          padding: "8px",
                          flexShrink: 0
                        }}
                      >
                        <svg viewBox="0 0 24 24" style={{ width: "100%", height: "100%" }} xmlns="http://www.w3.org/2000/svg">
                          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22c-.87-2.6-2.86-4.53-6.16-4.53z" fill="#FBBC05"/>
                          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 6.64l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                        </svg>
                      </div>
                    </Col>
                    <Col xs={5} lg={6} className="testimonial-name">
                      <h6 className="mb-0 fw-bold" style={{ fontSize: "14px" }}>{mappedName}</h6>
                      <p className="d-block mb-0" style={{ fontSize: "11px", opacity: 0.85 }}>
                        {mappedDesignation}
                      </p>
                    </Col>
                    <Col xs={4} className="d-flex align-items-center justify-content-end">
                      <div className="bg-light align-items-center d-flex p-1 p-lg-2 rounded-pill shadow-sm">
                        {[...Array(Number(testimonial.client_rating))].map(
                          (_, i) => (
                            <StarFill
                              key={i}
                              color="gold"
                              className="me-xl-1 star-rating"
                            />
                          ),
                        )}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Container>
  );
};

export default Testimonial;
